import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging"
import { registerServiceWorker } from '@/plugins/register-service-work'
import BrowserNotificationError from '@/plugins/push-notification/BrowserNotificationError'
import credentials, { vapidKey } from './credencials'
import Service from './service'
import store from '@/store'

let messaging = null
let messageActions = {}

function saveToken(newToken)
{
    const userTokens = store().auth.notificationTokens.filter(i => i.token_type === 'fcm').map(i => i.token)

    if(!userTokens.includes(newToken)) {
        let index = userTokens.findIndex(value => value.split(':')[0] === newToken.split(':')[0])

        if(index >= 0) {
             Service.refreshNotificationToken(userTokens[index], newToken).then(() => {
                 userTokens[index] = newToken
             })
            .catch(() => {})
        } else {
            Service.createNotificationToken(newToken, 'fcm').then(() => {
                 userTokens.push(newToken)
            })
            .catch(() => {})
        }
    }
}

function registerListener() {
    onMessage(messaging, (payload) => {
        let action = messageActions[payload.data.action]

        if (Array.isArray(action)) {
            action.forEach(fn => typeof fn === 'function' && fn(payload))
        }
    })

    if ('serviceWorker' in navigator) {
        // Verifica as ações recebidas no background para executar no client quando o client está sem segundo plano
        // O service work só manda essa ação caso o payload tenha a chave 'always_notify_client'
        navigator.serviceWorker.addEventListener('message', event => {
            let action = messageActions[event.data.action]

            if (Array.isArray(action)) {
                action.forEach(fn => typeof fn === 'function' && fn(event.data.payload))
            }
        })
    }
}

async function initMessaging() {
    if (!await isSupported()) {
        throw BrowserNotificationError.createNoSupport()
    }

    return messaging = messaging || getMessaging(initializeApp(credentials));
}

async function swToken() {
    const options = {
        vapidKey,
        serviceWorkerRegistration: await registerServiceWorker(),
    }

    try {
        return await getToken(messaging, options)
    } catch (error) {
        if (error.code !== 'messaging/token-update-failed') {
            throw error
        }
    }

    return await getToken(messaging, options)
}

async function generateToken() {
    await initMessaging()

    return await swToken()
}

export default {
    async start() {
        let token = await generateToken()

        registerListener()

        saveToken(token)
    },

    async destroyToken() {
        let token = await generateToken()

        await Service.destroyNotificationToken(token).catch(() => {})
    },

    getMessaging() {
        return messaging;
    },

    addAction(action, callback) {
        messageActions[action] = messageActions[action] || []

        messageActions[action].push(callback)
    },

    addActions(actions) {
        for (let i in actions) {
            this.addAction(i, actions[i])
        }
    },

    setActions(actions) {
        for (let i in actions) {
            messageActions[i] = []

            this.addAction(i, actions[i])
        }
    }
}
